module.exports = "https://static.wanderu.com/static/media/economist-x2.52b81e9f.png";